import { render, staticRenderFns } from "./InviteFriendsEmailsTable.vue?vue&type=template&id=aedc426e&scoped=true&"
import script from "./InviteFriendsEmailsTable.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsEmailsTable.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriendsEmailsTable.vue?vue&type=style&index=0&id=aedc426e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedc426e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
